<div class="container">
  <kendo-chat
    class="chat"
    [messages]="feed | async"
    [authorId]="user.id"
    (sendMessage)="sendMessage($event)"
  >
  </kendo-chat>
</div>
